import { UserState, UserMutations, UserActions } from '../types'
import api from '@/api'
import { UserCommitInfomation } from './mutation-types'

const state: UserState = {
  isLoggedIn: false,
  id: 0,
  name: '',
  email: '',
  updatedAt: '',
  status: {
    errors: false,
    message: ''
  }
}
const mutations: UserMutations = {
  infomation (state, payload) {
    state = Object.assign(state, payload)
  }
}
const actions: UserActions = {
  get ({ commit, rootState }) {
    api.user.get(rootState.auth).then(resp => {
      /* eslint-disable camelcase */
      const { id, name, email, updated_at } = resp.data
      commit<UserCommitInfomation>({
        type: 'infomation',
        isLoggedIn: true,
        id,
        name,
        email,
        updatedAt: updated_at,
        status: {
          errors: false,
          message: resp.message
        }
      })
    })
  }
}

export const user = {
  state,
  mutations,
  actions
}
